<template>
  <div>
    <v-tabs grow icons-and-text v-model="tab" height="6.5rem">
      <v-tab
        data-testid="current-agent-my-deals-tab"
        class="current-agent-my-deals-tab"
      >
        <span class="text-subtitle-1 mt-2 mb-0">My Deals</span>
        <v-icon large>folder</v-icon>
      </v-tab>
      <v-tab
        data-testid="current-agent-my-phone-rentals-tab"
        class="current-agent-my-phone-rentals-tab"
      >
        <span class="text-subtitle-1 mt-2 mb-0">My Phone Rentals</span>
        <v-icon large>phone</v-icon>
      </v-tab>
      <v-tab
        v-if="currentUserIsAdmin"
        data-testid="current-agent-agent-deals-tab"
        class="current-agent-agent-deals-tab"
      >
        <span class="text-subtitle-1 mt-2 mb-0">Agent Deals</span>
        <v-icon large>face</v-icon>
      </v-tab>
      <v-tab
        v-if="currentUserIsAdmin"
        data-testid="current-agent-agent-phone-rentals-tab"
        class="current-agent-agent-phone-rentals-tab"
      >
        <span class="text-subtitle-1 mt-2 mb-0">Agent Phone Rentals</span>
        <v-icon large>group</v-icon>
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" class="mt-6 rounded-lg">
      <v-tab-item eager>
        <v-card flat>
          <current-agent-leads ref="leads" />
        </v-card>
      </v-tab-item>
      <v-tab-item eager>
        <v-card flat>
          <current-agent-phone-rentals ref="rentals" />
        </v-card>
      </v-tab-item>
      <v-tab-item v-if="currentUserIsAdmin" eager>
        <v-card flat>
          <agents-leads ref="agentLeads" />
        </v-card>
      </v-tab-item>
      <v-tab-item v-if="currentUserIsAdmin" eager>
        <v-card flat>
          <agents-phone-rentals ref="agentRentals" />
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
/* eslint-disable eqeqeq */
import AgentsLeads from "@/components/AgentsLeads";
import AgentsPhoneRentals from "@/components/AgentsPhoneRentals";
import CurrentAgentLeads from "@/components/CurrentAgentLeads";
import CurrentAgentPhoneRentals from "@/components/CurrentAgentPhoneRentals";

export default {
  data() {
    return {
      tab: 0
    };
  },
  components: {
    AgentsPhoneRentals,
    CurrentAgentLeads,
    CurrentAgentPhoneRentals,
    AgentsLeads
  },
  methods: {
    getLeads: async function() {
      await this.$store.dispatch("getCurrentAgentLeads");
    },
    getPhoneRentals: async function() {
      await this.$store.dispatch("getCurrentAgentPhoneRentals");
    },
    getAgentsList: async function() {
      await this.$store.dispatch("getAgentsList");
    }
  },
  computed: {
    currentUserIsAdmin: function() {
      return this.$store.getters.isAdmin;
    }
  },
  created() {
    this.getLeads();
    this.getPhoneRentals();
    this.getAgentsList();
  }
};
</script>
